import { render, staticRenderFns } from "./AdPlannerQuery.vue?vue&type=template&id=53808d68&scoped=true"
import script from "./AdPlannerQuery.vue?vue&type=script&lang=js"
export * from "./AdPlannerQuery.vue?vue&type=script&lang=js"
import style0 from "./AdPlannerQuery.vue?vue&type=style&index=0&id=53808d68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53808d68",
  null
  
)

export default component.exports